module.exports = __webpack_public_path__ + "static/b3-924fe0bde05b4100de299823f29c5298.png";